"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Close = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n  display: flex;\n  align-items: center;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  height: 28px;\n  padding: 5px 16px;\n  margin-right: 10px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  white-space: nowrap;\n  user-select: none;\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n  display: flex;\n  align-items: center;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  height: 28px;\n  padding: 5px 16px;\n  margin-right: 10px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  white-space: nowrap;\n  user-select: none;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  font-size: 20px;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", ";\n  margin-left: 8px;\n  margin-bottom: 2px;\n  cursor: pointer;\n"], ["\n  display: flex;\n  font-size: 20px;\n  align-items: center;\n  justify-content: center;\n  font-weight: ", ";\n  margin-left: 8px;\n  margin-bottom: 2px;\n  cursor: pointer;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _buoyTheme = require("buoy-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PillContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__PillContainer",
  componentId: "sc-5xkpyk-0"
})(_templateObject, _buoyTheme.fontFamily, _buoyTheme.fontWeight.regular, (0, _buoyTheme.fontSize)('bodyMain'), _buoyTheme.colors.neutralDarkest, _buoyTheme.colors.neutralLightest);

var Close = exports.Close = _styledComponents2.default.div.withConfig({
  displayName: "src__Close",
  componentId: "sc-5xkpyk-1"
})(_templateObject2, _buoyTheme.fontWeight.light);

var Pill = function Pill(_ref) {
  var text = _ref.text,
      onRemove = _ref.onRemove,
      readonly = _ref.readonly;
  return _react2.default.createElement(
    PillContainer,
    null,
    text,
    !readonly && _react2.default.createElement(
      Close,
      { onClick: onRemove },
      "\xD7"
    )
  );
};

Pill.propTypes = {
  text: _propTypes2.default.string.isRequired,
  onRemove: _propTypes2.default.func,
  readonly: _propTypes2.default.bool
};

exports.default = Pill;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-pill/dist/index.js
// module id = 434
// module chunks = 168707334958949